import { PickupAndDeliveryState } from '~/components/vdp/PickupAndDelivery';
import DeliveryLarge from '~/icons/DeliveryLarge';
import DeliveryMedium from '~/icons/DeliveryMedium';
import DeliverySmall from '~/icons/DeliverySmall';
import VendingLarge from '~/icons/VendingLarge';
import VendingMedium from '~/icons/VendingMedium';
import VendingSmall from '~/icons/VendingSmall';

const icons = {
  delivery: {
    small: DeliverySmall,
    medium: DeliveryMedium,
    large: DeliveryLarge
  },
  pickup: {
    small: VendingSmall,
    medium: VendingMedium,
    large: VendingLarge
  }
};

export default function getIconToUse(
  componentState: PickupAndDeliveryState,
  component: 'pickup' | 'delivery'
) {
  const iconSetToUse = icons[component];
  const getIconSize = (() => {
    switch (true) {
      case componentState === PickupAndDeliveryState.MobileWithCars:
      case componentState === PickupAndDeliveryState.MobileWithNoCars:
        return 'small';
      case componentState === PickupAndDeliveryState.DesktopWithCars:
        return 'medium';
      default:
        return 'large';
    }
  })();

  return iconSetToUse[getIconSize];
}
